<template>
  <div>
    <div class="d-flex mb-4">
      <div class="card">
        <div class="card-body">
          <h1 class="h4">BTC <small class="text-muted">(testnet3)</small></h1>
          <h2 class="h2 font-weight-light">{{ balance.btc }}</h2>
          <h3 class="h6 mb-0 font-weight-light text-muted">{{ address.btc }}</h3>
        </div>
      </div>
      <div class="card ml-4">
        <div class="card-body">
          <h1 class="h4">ETH <small class="text-muted">(rinkeby)</small></h1>
          <h2 class="h2 font-weight-light">{{ balance.eth }}</h2>
          <h3 class="h6 mb-0 font-weight-light text-muted">{{ address.eth }}</h3>
        </div>
      </div>
    </div>
    <table class="table bg-white border mb-4">
      <thead>
        <tr>
          <td scope="col" class="text-muted">#</td>
          <td scope="col" class="text-muted">Pair</td>
          <td scope="col" class="text-muted">Rate</td>
          <td scope="col" class="text-muted">Trade</td>
        </tr>
      </thead>
      <tbody class="font-weight-normal">
        <tr v-if="marketinfo.length === 0">
          <td colspan="4" class="text-center font-weight-light text-muted">Fetching market data...</td>
        </tr>
        <tr v-for="(market, idx) in marketinfo" :key="market.to + '-' + market.from">
          <td scope="row" class="text-muted font-weight-light">{{idx + 1}}</td>
          <td>{{market.from}} <small class="text-muted">/ {{market.to}}</small></td>
          <td><small class="text-muted">1 {{market.from}} =</small> {{market.rate}} <small class="text-muted">{{market.to}}</small></td>
          <td><button class="btn btn-block btn-lg btn-primary" @click="buy(market.from, market.to)">Buy {{market.to}}</button></td>
        </tr>
      </tbody>
    </table>
    <table class="table border bg-white">
      <thead>
        <tr>
          <td scope="col" class="text-muted">#</td>
          <td scope="col" class="text-muted">Description</td>
          <td scope="col" class="text-muted">Rate</td>
          <td scope="col" class="text-muted">Progress</td>
          <td scope="col" class="text-muted">Status</td>
        </tr>
      </thead>
      <tbody class="font-weight-normal">
        <tr v-if="latestOrders.length === 0">
          <td colspan="4" class="text-center font-weight-light text-muted">No previous orders found</td>
        </tr>
        <tr v-for="(order, idx) in latestOrders" :key="order.id">
          <td scope="row" class="text-muted font-weight-light">{{orders.length - idx}}</td>
          <td>+{{prettyAmount(order.to, order.toAmount)}} {{order.to}} <small class="text-muted">/ -{{prettyAmount(order.from, order.fromAmount)}} {{order.from}}</small></td>
          <td><small class="text-muted">1 {{order.from}} =</small> {{order.rate}} <small class="text-muted">{{order.to}}</small></td>
          <td class="text-muted">25%</td>
          <td><button :class="{
            'btn btn-block btn-lg': true,
            'btn-outline-primary': order.status.toLowerCase() !== 'success',
            'btn-outline-success': order.status.toLowerCase() === 'success'
          }">{{order.status}}</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { random } from 'lodash-es'
import axios from 'axios'
import { mapState } from 'vuex'
import { sha256 } from '@liquality/crypto'
import cryptoassets from '@liquality/cryptoassets'

import workerManager from '../utils/worker-manager'

const agent = 'http://localhost:8010/proxy/swap-testnet-dev/agent/api/swap'

function newOrder (data) {
  return axios({
    url: agent + '/order',
    method: 'post',
    data
  }).then(res => res.data)
}

function updateOrder (id, data) {
  return axios({
    url: agent + '/order/' + id,
    method: 'post',
    data
  }).then(res => res.data)
}

function getMarketInfo (id, data) {
  return axios({
    url: agent + '/marketinfo'
  }).then(res => res.data)
}

export default {
  data () {
    return {
      balance: {
        btc: '...',
        eth: '...'
      },
      address: {
        btc: '...',
        eth: '...'
      },
      marketinfo: []
    }
  },
  computed: {
    ...mapState(['orders']),
    latestOrders () {
      return this.orders.slice().reverse()
    }
  },
  methods: {
    async updateMarket () {
      this.marketinfo = (await getMarketInfo()).filter(market => ['ETH', 'BTC'].includes(market.to) && ['ETH', 'BTC'].includes(market.from))

      setTimeout(() => {
        this.updateMarket()
      }, random(15000, 30000))
    },
    updateBalance () {
      Object
        .keys(this.balance)
        .map(asset => {
          workerManager(asset)('wallet.getUsedAddresses', 'Address')().then(addresses => {
            workerManager(asset)('chain.getBalance', 'BigNumber')(addresses).then(balance => {
              this.balance[asset] = cryptoassets[asset].unitToCurrency(balance)
            })
          })
        })
    },
    prettyAmount (chain, amount) {
      return cryptoassets[chain.toLowerCase()].unitToCurrency(amount)
    },
    buy (from, to) {
      this.swap(from, to)
    },
    async getUnusedAddresses (order) {
      const [fromAddress, toAddress] = await Promise.all([
        workerManager(order.from)('wallet.getUnusedAddress', 'Address')(),
        workerManager(order.to)('wallet.getUnusedAddress', 'Address')()
      ])

      this.address[order.to.toLowerCase()] = toAddress
      this.address[order.from.toLowerCase()] = fromAddress

      return [fromAddress, toAddress]
    },
    checkOrderHistory () {
      this.orders.forEach(order => {
        if (!order.status) return
        if (['quote', 'success'].includes(order.status.toLowerCase())) return

        console.log('Continuing', order.id, order.status)

        this.performNextAction(order)
      })
    },
    async performNextAction (order) {
      if (!order.status) return

      if (order.status.toLowerCase() === 'quote') {
        const [fromAddress, toAddress] = await this.getUnusedAddresses(order)

        const secret = await workerManager(order.from)('swap.generateSecret')('ccp')
        const secretHash = sha256(secret)

        order = {
          ...order,
          secret,
          fromAddress,
          toAddress,
          secretHash,
          status: 'Secured'
        }

        this.$store.commit('UPDATE_ORDER', order)

        this.performNextAction(order)
      } else if (order.status.toLowerCase() === 'secured') {
        const fromFundHash = await workerManager(order.from)('swap.initiateSwap')(
          order.fromAmount,
          order.fromCounterPartyAddress,
          order.fromAddress,
          order.secretHash,
          order.swapExpiration
        )

        order = {
          ...order,
          fromFundHash,
          status: 'Initiated'
        }

        await updateOrder(order.id, {
          fromAddress: order.fromAddress,
          toAddress: order.toAddress,
          fromFundHash: order.fromFundHash,
          secretHash: order.secretHash
        })

        this.$store.commit('UPDATE_ORDER', order)

        this.performNextAction(order)
      } else if (order.status.toLowerCase() === 'initiated') {
        const interval = setInterval(async () => {
          let tx = await workerManager(order.to)('swap.findInitiateSwapTransaction')(
            order.toAmount, order.toAddress, order.toCounterPartyAddress, order.secretHash, order.nodeSwapExpiration
          )

          if (tx) {
            clearInterval(interval)

            const toFundHash = tx.hash

            order = {
              ...order,
              toFundHash,
              status: 'Exchanging'
            }

            this.$store.commit('UPDATE_ORDER', order)

            this.performNextAction(order)
          }
        }, random(15000, 30000))
      } else if (order.status.toLowerCase() === 'exchanging') {
        await workerManager(order.to)('swap.claimSwap')(
          order.toFundHash,
          order.toAddress,
          order.toCounterPartyAddress,
          order.secret,
          order.nodeSwapExpiration
        )

        order = {
          ...order,
          status: 'Success'
        }

        this.$store.commit('UPDATE_ORDER', order)
      }
    },
    async swap (from, to) {
      const order = await newOrder({
        from,
        to,
        fromAmount: 80000
      })

      order.status = 'Quote'

      this.$store.commit('NEW_ORDER', order)

      this.performNextAction(order)
    }
  },
  async created () {
    this.updateMarket()
    this.updateBalance()
    this.getUnusedAddresses({ to: 'BTC', from: 'ETH' })
    this.checkOrderHistory()
  }
}
</script>

<style lang="scss">
button {
  code, pre {
    color: inherit;
  }
}
.text-muted, .text-white {
  code, pre {
    color: inherit;
  }
}
.btn {
  text-align: left!important;
}
.card-body {
  .mb-2:last-child {
    margin-bottom: 0!important;
  }
}

.form-control {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  outline: 0;
  box-shadow: none;
  padding: 0;

  &[readonly] {
    background: white;
  }

  &:hover, &:focus, &:active {
    outline: 0;
    box-shadow: none;
  }
}

.table {
  font-size: 1rem;

  th, td {
    vertical-align: middle;
  }

  thead > tr {
    td {
      border: 0;
    }
  }

  tr {
    > td:first-child, > td:nth-child(3), > td:nth-child(4), > td:nth-child(5) {
      width: 1%;
      white-space: nowrap;
    }
  }
}

td > .badge {
  text-align: center;
  font-weight: 400;
  padding: 0.5rem;
  width: 100%;
}

td > .btn {
  text-align: center!important;
}

.btn {
  font-weight: 400!important;
}
</style>
